import getCart from './getCart';

const getCartDeliveryTimeExpected = state => {
  const deliveryTime = getCart(state)?.deliveryTime;
  if (deliveryTime) {
    return {
      maxMinutes: deliveryTime.maxMinutes,
      minMinutes: deliveryTime.minMinutes,
      description: deliveryTime.description,
    };
  }
  return null;
};

export default getCartDeliveryTimeExpected;
